import { createSentryPiniaPlugin } from '@sentry/vue'
import { defineVuePlugin } from '#/vue-plugins'
import { createPinia } from 'pinia'

export default defineVuePlugin((app) => {
  const pinia = createPinia()
  pinia.use(
    createSentryPiniaPlugin({
      stateTransformer: (state) => {
        if (state.accessToken) {
          return {
            ...state,
            accessToken: '',
          }
        }

        return state
      },
    }),
  )

  app.use(pinia)
})
